module.exports = new __parcel__URL__("78566_sq.8c44deec.jpg").toString();